export default __webpack_public_path__ + "static/media/d54.f92497f9.png";